import { AbsgArrayHelper } from '@absg/angular-common';
import { PatientLite } from '@absg/api-party';
import { PickListItem } from '@absg/nim-client-shared';

export class PatientOwnedItemHelper {

  static setDisabled(patientOwnedItemList: PickListItem[], patientOwnedItemTypeIdList: number[]): PickListItem[] {
    return AbsgArrayHelper.each(patientOwnedItemList, patientOwnedItem => {
      patientOwnedItem.isDisabled = this.isPatientOwnedTypeId(patientOwnedItemTypeIdList, patientOwnedItem.id);
    });
  }

  static isPatientOwnedTypeId(patientOwnedItemTypeIdList: number[], patientOwnedItemTypeIdentifier: number): boolean {
    const patientOwnedItemId =  AbsgArrayHelper.find(patientOwnedItemTypeIdList, patientOwnedItemTypeId =>
      patientOwnedItemTypeId === patientOwnedItemTypeIdentifier);
    return !! patientOwnedItemId;
  }

  static searchPatientFields(patient: PatientLite, filterValue: string): boolean {
    if (patient) {
      return ((patient.idNumber?.toLowerCase().includes(filterValue))
        || (patient.firstName?.toLowerCase().includes(filterValue))
        || (patient.lastName?.toLowerCase().includes(filterValue))
      );
    } else {
      return false;
    }
  }
}
